import React, { Fragment } from 'react'

import { Slide } from '../../display_wallet'
import { With2Tabs } from "../../components/With2Tabs"
import Slide_BlacklistAddress from './Slide_BlacklistAddress'
import Slide_BurnOwnTokens from './Slide_BurnOwnTokens'


export default class Slide_Burn extends React.PureComponent {
	constructor(props) {
		super(props)
	}

	render() {
		var jsx_slide_burnmycoins =
			<Fragment>
				<Slide_BurnOwnTokens {...this.props} />
			</Fragment>

		var jsx_slide_blacklistaddress =
			<Fragment>
				<Slide_BlacklistAddress {...this.props} />
			</Fragment>

		return (
			<Slide num={this.props.num} dontaddspacebelow style={{ paddingTop: "0px", overflowX: "hidden" }}>
				<With2Tabs
					startingtab="1"
					title_tab1="Burn de Delphes"
					title_tab2="Blacklist d'adresse"
					content_tab1={jsx_slide_burnmycoins}
					content_tab2={jsx_slide_blacklistaddress}
				/>
			</Slide>
		)
	}
}
